import {Component, OnInit, AfterViewInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {DeslocamentoApiService} from "../shared/deslocamento-api.service";
import {UtilService} from "../../../shared/services/util.service";
import {deslocamentosModuleName, statusDeslocamentos} from "../shared/data.service";
import {Deslocamento} from "../shared/deslocamento.model";
import {DeslocamentoNavigationService} from "../shared/deslocamento-navigation.service";
import {DeslocamentoService} from "../shared/deslocamento.service";
import {viagensModuleName} from "../../shared/data.service";
import {Frota} from "../../../bens/frotas/shared/frota.model";
import {Motorista} from "../../../recursos-humanos/motoristas/shared/motorista.model";
import {MotoristaApiService} from "../../../recursos-humanos/motoristas/shared/motorista-api.service";
import {MotoristaService} from "../../../recursos-humanos/motoristas/shared/motorista.service";
import {FrotaApiService} from "../../../bens/frotas/shared/frota-api.service";
import {FrotasService} from "../../../bens/frotas/shared/frota.service";
import {frotasQuery} from "../../../bens/frotas/shared/data.service";
import {motoristasQuery} from "../../../recursos-humanos/motoristas/shared/data.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {FormaControleService} from "../../../bens/formas-controle/shared/forma-controle.service";
import {PassageiroApiService} from "../../passageiros/shared/passageiro-api.service";
import {PontoApiService} from "../../pontos/shared/ponto-api.service";
import {PontoService} from "../../pontos/shared/ponto.service";

@Component({
    template: require('./delocamento-detail.component.html'),
    styles: [require('./delocamento-detail.component.css')]
})
export class DelocamentoDetailComponent implements OnInit, AfterViewInit {
    deslocamentosModule: any = deslocamentosModuleName;
    module: any = viagensModuleName;
    detail: any = new Deslocamento();
    tabSelected: string = 'detalhes';
    isAdm: boolean = false;
    formObject: any = {};
    frotaObject: any = new Frota();
    motoristaObject: any = new Motorista();
    statusObject: any = {};
    statusList: any[] = [];
    isDriver: boolean = false;
    submitted: boolean = false;
    tipoSaida: number;
    tipoViagem: number;
    deslocamentoTipoId: number;
    deslocamentoId: number;

    frotaSelectId: string = 'frota';
    frotaQuery: string;
    motoristaSelectId: string = 'motorista';
    motoristaQuery: string;
    passageirosList: any[] = [];
    pontosList: any[] = [];
    custosList: any[] = [];

    statusCancelado: number;
    statusConcluido: number;
    statusAprovado: number;
    statusSolicitado: number;
    statusItem: number;

    form: FormGroup;
    status = new FormControl('', Validators.required);
    justificativa = new FormControl('', Validators.required);
    motorista = new FormControl('', Validators.required);
    bem = new FormControl('', Validators.required);
    enderecoPartidaVeiculo = new FormControl('', Validators.required);
    dataRetorno = new FormControl('', Validators.required);
    dataSaida = new FormControl('', Validators.required);
    horaSaida = new FormControl('', Validators.required);
    horaRetorno = new FormControl('', Validators.required);
    observacao = new FormControl('');
    horasTrabalhadas = new FormControl('');

    titulo = new FormControl('', Validators.required);
    numeroRequisicao = new FormControl('', Validators.required);

    private veiculoCategoriaId: number;

    constructor(
        private _deslocamentoApiService: DeslocamentoApiService,
        private _deslocamentoNavigationService: DeslocamentoNavigationService,
        private _deslocamentoService: DeslocamentoService,
        private _motoristaApiService: MotoristaApiService,
        private _motoristaService: MotoristaService,
        private _frotaApiService: FrotaApiService,
        private _frotaService: FrotasService,
        private _passageiroApiService: PassageiroApiService,
        private _pontoApiService: PontoApiService,
        private _pontoService: PontoService,
        private _formaControleService: FormaControleService,
        private _autocompleteService: AutoCompleteService,
        private _route: ActivatedRoute,
        private _utilService: UtilService,

        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            status: this.status,
            justificativa: this.justificativa,
            motorista: this.motorista,
            bem: this.bem,
            enderecoPartidaVeiculo: this.enderecoPartidaVeiculo,
            dataRetorno: this.dataRetorno,
            dataSaida: this.dataSaida,
            observacao: this.observacao,
            horaSaida: this.horaSaida,
            horaRetorno: this.horaRetorno,
            titulo: this.titulo,
            numeroRequisicao: this.numeroRequisicao,
            horasTrabalhadas: this.horasTrabalhadas
        });
    }

    ngOnInit() {
        this.isAdm = this._deslocamentoService.checkVisitor();
        this.tipoSaida = this._deslocamentoService.getTipoSaida();
        this.tipoViagem = this._deslocamentoService.getTipoViagem();

        this.deslocamentoId = +this._route.snapshot.params['id'];
        this.getObject(this.deslocamentoId);
        this.getPassageiros(this.deslocamentoId);

        if (this.isAdm) {
            this.getPontos(this.deslocamentoId);
            this.getCustos(this.deslocamentoId);
        }
    }

    ngAfterViewInit() {

    }

    clickEdit() {
        this._deslocamentoNavigationService.goToEdit(this.detail.id);
    }

    clickList() {
        this._deslocamentoNavigationService.goToList();
    }

    changeStatus() {
        this.statusItem = this._utilService.cloneObject(this.statusObject.Key);
    }

    setTab(tab:string) {
        this.tabSelected = tab;
        if (tab === 'status') {
            this.setDados();
        }
    }

    isTab(tab: string) {
        var isTab: boolean = (tab === this.tabSelected) ? true: false;
        return isTab;
    }

    onSubmit(evt: any) {
        this.submitted = true;

        if (this.statusItem === this.statusAprovado) {
            if (this.isDriver) {
                this._utilService.setSelectOnFormControl(this.form, 'enderecoPartidaVeiculo', 'x');
            } else {
                this._utilService.setSelectOnFormControl(this.form, 'motorista', {id: -1});
            }
            this._utilService.setSelectOnFormControl(this.form, 'justificativa', 'x');
            this._utilService.setSelectOnFormControl(this.form, 'dataSaida', 'x');
            this._utilService.setSelectOnFormControl(this.form, 'horaSaida', 'x');
            this._utilService.setSelectOnFormControl(this.form, 'dataRetorno', 'x');
            this._utilService.setSelectOnFormControl(this.form, 'horaRetorno', 'x');
        } else if(this.statusItem === this.statusCancelado) {
            this._utilService.setSelectOnFormControl(this.form, 'enderecoPartidaVeiculo', 'x');
            this._utilService.setSelectOnFormControl(this.form, 'motorista', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'bem', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'dataRetorno', 'x');
            this._utilService.setSelectOnFormControl(this.form, 'horaRetorno', 'x');
            this._utilService.setSelectOnFormControl(this.form, 'dataSaida', 'x');
            this._utilService.setSelectOnFormControl(this.form, 'horaSaida', 'x');
        } else if(this.statusItem === this.statusConcluido) {
            this._utilService.setSelectOnFormControl(this.form, 'enderecoPartidaVeiculo', 'x');
            this._utilService.setSelectOnFormControl(this.form, 'motorista', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'justificativa', 'x');
            this._utilService.setSelectOnFormControl(this.form, 'bem', {id: -1});

            if (!this.formObject.odometroSaida || !this.formObject.odometroRetorno) {
                return false;
            }
        }

        if (this.deslocamentoTipoId === this.tipoSaida) {
            this._utilService.setSelectOnFormControl(this.form, 'titulo', 'x');
            this._utilService.setSelectOnFormControl(this.form, 'numeroRequisicao', 'x');
        }

        if(evt.valid) {
            let object: any = this._utilService.cloneObject(this.formObject);

            if (this.motoristaObject.id) {
                object.motoristaDesignadoId = this.motoristaObject.id;
            }

            if (this.frotaObject.id) {
                object.bemId = this.frotaObject.id;
            }

            if (this.statusItem === this.statusConcluido) {
                let date: any = document.getElementById('data_saida');
                let time: any = document.getElementById('hora_saida');
                if (date.value && time.value) {
                    object.dataHoraEfetivaSaida = this._utilService.convertStringToDateTime(date.value, time.value);
                    delete object['dataSaida'];
                    delete object['horaSaida'];
                }

                date = document.getElementById('data_retorno_efetivo');
                time = document.getElementById('hora_retorno_efetivo');
                if (date.value && time.value) {
                    object.dataHoraEfetivaRetorno = this._utilService.convertStringToDateTime(date.value, time.value);

                    delete object['dataRetorno'];
                    delete object['horaRetorno'];
                }

                object.kmSaida = this._formaControleService.submitOdometroHorimetro(object.odometroSaida);
                delete object['odometroSaida'];

                object.kmRetorno = this._formaControleService.submitOdometroHorimetro(object.odometroRetorno);
                delete object['odometroRetorno'];
            }

            object.status = this.statusItem;
            object.id = this.detail.id;

            this.onEditDeslocamento(object);

        }
    }

    getMotoristasObject(object: any) {
        this.motoristaObject = object;
        this._utilService.setSelectOnFormControl(this.form, 'motorista', object);
    }

    getFrotasObject(object: any) {
        this.frotaObject = object;
        this._utilService.setSelectOnFormControl(this.form, 'bem', object);
    }

    frotaTemplateResult = (function(state: any) {
        var template: any = this._frotaService.templateResult(state, false);
        return template;
    }.bind(this));

    motoristaTemplateResult = (function(state: any) {
        var template: any = this._motoristaService.templateResult(state, false);
        return template;
    }.bind(this));

    private onEditDeslocamento(object: Deslocamento) {
        this._deslocamentoApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this._utilService.swalMessageEditSuccess();
            this.clickList();
        } else {
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(deslocamentoId: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.statusItem = this._utilService.cloneObject(Response.status);
                this.deslocamentoTipoId = Response.tipo;
                Response.tipo = this._deslocamentoService.getTipo(Response.tipo);
                Response.statusId = Response.status;
                Response.status = this._deslocamentoService.getStatus(Response.status);

                this.detail = Response;
                if (this.isAdm && this.detail.id) {
                    this.setAdmSettings();
                }
            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma solicitação encontrada com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._deslocamentoApiService.onGetById(deslocamentoId, onDone);
    }

    private getPassageiros(deslocamentoId: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.passageirosList = Response;
            }
        }.bind(this));

        let query: any = {
            where: {
                ativo: true,
                deslocamentoId: deslocamentoId
            }
        };
        this._passageiroApiService.onGetPassageiroDeslocamento(query, onDone);
    }

    private getPontos(deslocamentoId: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number;
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    Response[x].tipo = this._pontoService.checkTipo(Response[x].tipo);
                }

                this.pontosList = Response;
            }
        }.bind(this));

        let query: any = {
            where: {
                ativo: true,
                deslocamentoId: deslocamentoId
            }
        };
        this._pontoApiService.onGetPontoDeslocamento(query, onDone);
    }

    private getCustos(deslocamentoId: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.custosList = Response;
            }
        }.bind(this));

        let query: any = {
            where: {
                ativo: true,
                deslocamentoId: deslocamentoId
            }
        };
        this._deslocamentoApiService.onGetCustoDeslocamento(query, onDone);
    }

    private setAdmSettings() {
        this.veiculoCategoriaId = this._frotaService.getTipoVeiculo();
        this.frotaQuery = this._utilService.cloneObject(frotasQuery);
        this.motoristaQuery = this._utilService.cloneObject(motoristasQuery);

        if (this.deslocamentoTipoId === this.tipoViagem) {
            this.isDriver = true;
        }

        this.statusList = this._utilService.cloneObject(statusDeslocamentos);
        if (this.detail.status) {
            let x: number, lenX: number;
            for (x = 0, lenX = this.statusList.length; x < lenX; x++) {
                if (this.statusList[x].Key === this.statusItem) {
                    this.statusObject = this.statusList[x];
                    break;
                }
            }
        }

        if (this.detail.enderecoPartidaSolicitante) {
            this.isDriver = true;
        }

        this.statusCancelado = this._deslocamentoService.getStatusCancelado();
        this.statusAprovado = this._deslocamentoService.getStatusAprovado();
        this.statusConcluido = this._deslocamentoService.getStatusConcluido();
        this.statusSolicitado = this._deslocamentoService.getStatusSolicitado();

        if (this.detail.enderecoPartidaVeiculo) {
            this.formObject.enderecoPartidaVeiculo = this.detail.enderecoPartidaVeiculo;
        }

        if (this.detail.justificativa) {
            this.formObject.justificativa = this.detail.justificativa;
        }

        if (this.detail.bem) {
            this.frotaObject = this.detail.bem;
        }

        if (this.detail.motoristaDesignado) {
            this.motoristaObject = this.detail.motoristaDesignado;
        }

        if (this.detail.observacao) {
            this.formObject.observacao = this.detail.observacao;
        }

        if (this.detail.titulo) {
            this.formObject.titulo = this.detail.titulo;
        }

        if (this.detail.numeroRequisicao) {
            this.formObject.numeroRequisicao = this.detail.numeroRequisicao;
        }

        if (this.detail.kmSaida) {
            this.detail.odometroSaida = this._formaControleService.setOdometroHorimetroToForm(this.detail.kmSaida.odometroHorimetro);
            this.formObject.odometroSaida = this.detail.odometroSaida;
        }

        if (this.detail.kmRetorno) {
            this.detail.odometroRetorno = this._formaControleService.setOdometroHorimetroToForm(this.detail.kmRetorno.odometroHorimetro);
            this.formObject.odometroRetorno = this.detail.odometroRetorno;
        }

        if (this.detail.dataHoraEfetivaSaida) {
            if (this.detail.dataHoraEfetivaSaida.indexOf("/") === -1) {
                this.formObject.dataSaida = this._utilService.convertDateToString(this.detail.dataHoraEfetivaSaida);
                this.formObject.horaSaida = this._utilService.convertTimeToString(this.detail.dataHoraEfetivaSaida);
            }
        }

        if (this.detail.dataHoraEfetivaRetorno) {
            if (this.detail.dataHoraEfetivaRetorno.indexOf("/") === -1) {
                this.formObject.dataRetorno = this._utilService.convertDateToString(this.detail.dataHoraEfetivaRetorno);
                this.formObject.horaRetorno = this._utilService.convertTimeToString(this.detail.dataHoraEfetivaRetorno);
            }
        }

        this.setDados();
    }

    private setDados() {
        setTimeout(function() {
            var selectObject:any = {text: this.frotaObject.identificacao, id: this.frotaObject.id};
            this._autocompleteService.createOptionOnSelect2(this.frotaSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.frotaSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'bem', this.frotaObject);

            if (this.motoristaObject) {
                if (this.motoristaObject.funcionario) {
                    if (this.motoristaObject.funcionario.pessoa) {
                        selectObject = {text: this.motoristaObject.funcionario.pessoa.nome, id: this.motoristaObject.id};
                        this._autocompleteService.createOptionOnSelect2(this.motoristaSelectId, selectObject);
                        this._autocompleteService.setValueOnSelect2(selectObject.id, this.motoristaSelectId);
                        this._utilService.setSelectOnFormControl(this.form, 'motorista', this.motoristaObject);
                    }
                }
            }
        }.bind(this));
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/delocamento-detail/delocamento-detail.component.ts
 **/